import { useCallback, useState } from "react";

export const useBilletCount = (onInput?: () => void) => {
  const [billetsCount, setBilletsCount] = useState<number>(0);

  const handleKeypadInput = useCallback(
    (digit: string) => {
      onInput?.();

      if (digit === "C") {
        setBilletsCount(0);
        return;
      }

      if (digit === "←") {
        setBilletsCount((prev) => Math.max(0, Math.floor(prev / 10)));
        return;
      }

      setBilletsCount((prev) => {
        const currentStr = prev === 0 ? "" : prev.toString();
        const newStr = currentStr + digit;
        const newValue = parseInt(newStr) || 0;
        return Math.max(0, newValue);
      });
    },
    [onInput],
  );

  return { billetsCount, setBilletsCount, handleKeypadInput };
};
